var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _class2, _descriptor, _descriptor2, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CustomElement, Component, Prop, html } from '@sick-davinci/ce-decorators';
import { style } from './ProgressLine.style';
/**
 * A Progress line is used to display the current progress of a task. 
 * 
 * @example
 * ```html
 * <davinci-progress-line percentage=50></davinci-progress-line>
 * <davinci-progress-line percentage=33 label="Updating" message="downloading..."></davinci-progress-line>
 * ```
 * @slot {*} right side next to progressline, can be used by button
 */

export let ProgressLine = (_dec = Component({
  tag: 'davinci-progress-line',
  style: [style]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Number), _dec(_class = (_class2 = (_temp = class ProgressLine extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "label", _descriptor, this);

    _initializerDefineProperty(this, "message", _descriptor2, this);

    this._innerPercentage = 0;
  }

  /**
   * Set the current progress in percentage.
   */
  set percentage(val) {
    this._innerPercentage = val < 0 ? 0 : val > 100 ? 100 : val;
  }

  get percentage() {
    return this._innerPercentage;
  }

  render() {
    return html`
    <div class="pl_label">${this.label}</div>
    <div class="pl_horizontal">
      <div class="pl_outer">
        <div class="pl_inner" style="width:${this._innerPercentage}%"></div>
      </div>
      <slot></slot>
    </div>
    <div class="pl_report">${this.message ? this.message : this._innerPercentage + '%'}</div>
    `;
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "message", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "percentage", [_dec6, _dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "percentage"), _class2.prototype)), _class2)) || _class);
//# sourceMappingURL=ProgressLine.js.map